const About = () => {
  return (
    <div className="about-us">
      <div className="container">
        <h1>مرحبا في راب سين</h1>
        <p>
          تاسست منظمة راب سين في عام 2018 لتغطية مشهد الراب في الشرق الاوسط كله
          ودعم الفنانين غير المعروفين (منتجي الموسيقى ودي جي والراقصين ومغني
          الراب)
        </p>
      </div>
    </div>
  );
};

export default About;
